module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar",
    class: _vm.classes
  }, [(_vm.photo) ? _c('img', {
    staticClass: "avatar__photo",
    attrs: {
      "src": _vm.photo,
      "alt": "Изображение"
    }
  }) : _c('MentoringAvatarStub', {
    attrs: {
      "type": _vm.type,
      "gender": _vm.gender,
      "asCurator": _vm.asCurator
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237382bf","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/avatar/MentoringAvatar.vue
// module id = f58095ae1da5d93fd734
// module chunks = 89